import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=6b46b8ed&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=6b46b8ed&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b46b8ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b46b8ed')) {
      api.createRecord('6b46b8ed', component.options)
    } else {
      api.reload('6b46b8ed', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=6b46b8ed&scoped=true", function () {
      api.rerender('6b46b8ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exercise/taskBase/detail.vue"
export default component.exports